import { render, staticRenderFns } from "./passwordRecover.vue?vue&type=template&id=4b8cce82&scoped=true&"
import script from "./passwordRecover.vue?vue&type=script&lang=js&"
export * from "./passwordRecover.vue?vue&type=script&lang=js&"
import style0 from "./passwordRecover.vue?vue&type=style&index=0&id=4b8cce82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cce82",
  null
  
)

/* custom blocks */
import block0 from "./passwordRecover.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "passwordRecover.vue"
export default component.exports